module.exports = __webpack_public_path__ + "img/s.77ac4b8e.jpg";